/**
 * @module providers
 */

import { error } from "console";
import React, { useEffect, useRef, useState } from "react";
import { ConfigsProvider } from "react-builder";
import { getCookie, getParameterByName, setCookie } from "react-builder";

/**
 * 
 */
export interface IPSupportRequest {
    email: string
    fullName: string
    mobileNumber: string
    type: string
    ccFourDigits: string
    countryCode: string
    captcha: string
}


export interface IPSupportRequestResponse {
    billingDomain: null
    billingPageId: null
    checkout: false
    disableEmbed: false
    externalBillingUrl: null
    fbid: null
    jsPostback: null
    message: string
    status: 9
    success: boolean
    transactionNum: null
    userIden: string
}

export interface IPSignupResponse { requestID: string, url: string, token: string }

export interface IPSignupData {
    email: string
    password: string
}

export interface IPAuthContext {
    isLoggedIn: boolean,
    isLoginDialogOpen: boolean,
    setLoginDialogOpen: React.Dispatch<React.SetStateAction<boolean>>,
    login: (email: string, password: string) => Promise<IPUserSession | void>,
    logout: () => Promise<boolean>//React.Dispatch<React.SetStateAction<boolean>>,
    sendSupportRequest: (data: IPSupportRequest) => Promise<{ message: string, success: boolean }>
    loginError?: string,
    signupError?: string,
    supportRequestError?: string,
    checkLoggedIn: (token: string) => Promise<IPUserSession>
    getSession(): IPUserSession | undefined
    resetPassword: (token: string, newPass: string) => Promise<{ message: string }>
}

export interface IPUserSession {
    _id: string
    firstName: string
    lastName: string
    email: string
    token: string
}

export const ProductServerAuthContext = React.createContext<IPAuthContext>({} as IPAuthContext);//<Auth>(new Auth());

/**
 * @module providers
 */
export const ProductServerAuth = (props: { children: any, site: string }) => {


    const cachedSession: string | undefined = getCookie('session');
    const [session, setSession] = useState<IPUserSession | undefined>(cachedSession ? JSON.parse(cachedSession) : undefined);

    const { children } = props;
    const [isLoggedIn, setLoggedIn] = useState(session != undefined);
    const [isLoginDialogOpen, setLoginDialogOpen] = useState(false);
    const [loginError, setLoginError] = useState<string>();
    const [signupError, setSignupError] = useState<string>();
    const [supportRequestError, setSupportRequestError] = useState<string>();
    // JSESSIONID=DF8914FFE6E5E8EDBDAC33C066833B87

    const api = useRef<string>(`${props.site}/api`);
    useEffect(() => {
        api.current = `${props.site}/api`;
    }, [props.site]);




    const contextValue: IPAuthContext = {
        isLoggedIn,
        isLoginDialogOpen,
        setLoginDialogOpen,
        getSession: () => (session ? { ...session } : undefined),
        checkLoggedIn: (token: string) => {

            return fetch(`${api.current}/auth/validate`, {
                headers: {
                    "content-type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                method: 'POST',
                body: JSON.stringify({

                })
            })
                .then(async response => {
                    if (response.status === 200) {
                        return response.json();
                    } else {
                        throw await response.json();
                    }
                })
                .then((result: IPUserSession) => {

                    setLoggedIn(true);
                    setSession(result);
                    setCookie('session', JSON.stringify(result), 1000 * 60 * 60 * 24);

                    return result;

                })
                .catch(error => {
                    setLoginError(error.message || 'Login failed');
                    throw 'Login failed';
                });
        },
        login: (e, p) => {
            var myHeaders = new Headers();

            myHeaders.append("content-type", "application/json");

            var body = {
                email: e,
                password: p
            }

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify(body),
            };

            setLoginError(undefined);

            return fetch(`${api.current}/auth/login`, requestOptions)
                .then(async response => {
                    if (response.status === 200) {
                        return response.json();
                    } else {
                        throw await response.json();
                    }
                })
                .then((result: IPUserSession) => {

                    setLoggedIn(true);
                    setSession(result);
                    setCookie('session', JSON.stringify(result), 1000 * 60 * 60 * 24);

                    return result;
                })
                .catch(error => {
                    setLoginError(error.message || 'Login failed');
                    throw 'Login failed';
                });
        },
        logout: () => new Promise((ok) => { setCookie('session', '', 10000000); setLoggedIn(false); setSession(undefined); ok(true) }),
        // signup: (u: string, p: string) => {

        //     var myHeaders = new Headers();

        //     myHeaders.append("content-type", "application/json");

        //     var body = {
        //         userEmail: u,
        //         userPassword: p,
        //         userPasswordConfirm: p,
        //         affiliate: getParameterByName('affiliate'),
        //         country: `${domain?.geo?.countryId ?? ''}`,
        //         clickId: getParameterByName('clickId'),
        //         theme: getParameterByName('theme'),
        //         pub: getParameterByName('pub'),
        //         subPub: getParameterByName('subPub'),
        //         productId: domain?.getProductId(),
        //         price: `${selectedPackage?.price}`
        //     }

        //     var requestOptions = {
        //         method: 'POST',
        //         headers: myHeaders,
        //         body: JSON.stringify(body),
        //     };

        //     setSignupError(undefined);

        //     return fetch(`${domain?.apiEndpoint}${domain?.getUserRestPath()}/register`, requestOptions)
        //         .then(response => response.json())
        //         .then((result: IPSignupResponse) => {
        //             if (!result.success) {
        //                 setSignupError(result.message);
        //             } else {
        //                 // redirect to billing page
        //                 getBillingUrl(result).then((r) => {

        //                     window.location.href = r;
        //                 })
        //             }

        //             return result;
        //         })
        //         .catch(error => {
        //             setSignupError('Signup failed');
        //         });
        // },
        sendSupportRequest: async (d) => {
            var myHeaders = new Headers();
            // myHeaders.append("content-type", "application/x-www-form-urlencoded");
            myHeaders.append("content-type", "application/json");
            // var urlencoded = new URLSearchParams();
            // urlencoded.append("name", d.fullName);
            // urlencoded.append("email", d.email);
            // urlencoded.append("cDigits", d.ccFourDigits);
            // urlencoded.append("msgCode", d.type);
            // urlencoded.append("countryCode", d.countryCode);
            // urlencoded.append("phoneNumber", d.mobileNumber);

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: JSON.stringify({
                    name: d.fullName,
                    email: d.email,
                    digits: d.ccFourDigits,
                    subject: d.type,
                    phoneCountryCode: d.countryCode,
                    phoneNumber: d.mobileNumber,
                    captcha: d.captcha,
                }),
            };

            setSupportRequestError(undefined);


            var action;
            switch (d.type) {
                case '0':
                    action = `${api.current}/support/cancel`
                    break;
                case '4':
                    action = `${api.current}/auth/resetPasswordRequest`
                    break;
                case '5':
                    action = `${api.current}/support/refund`
                    break;
                default:
                    setSupportRequestError('Please select request type');
                    return { success: false, message: '' };
            }

            return fetch(action, requestOptions)
                .then(async response => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        throw await response.json();
                    }
                })
                .then((result: { message: string }) => {

                    return { message: result.message, success: true };
                })
                .catch(error => {
                    setSupportRequestError(error.message);
                    return { message: error.message, success: false };
                });
        },
        loginError,
        signupError,
        supportRequestError,
        resetPassword: (token: string, newPass: string) => {

            try {

                var myHeaders = new Headers();
                myHeaders.append("content-type", "application/json");
                myHeaders.append("Authorization", `Bearer ${token}`);

                return fetch(`${api.current}/auth/resetPassword`, {
                    method: 'POST',
                    headers: myHeaders,
                    body: JSON.stringify({ newPassword: newPass })
                })
                    .then(async response => {
                        if (response.status === 200) {
                            return response.json();
                        } else {
                            throw await response.json();
                        }
                    })
            } catch (error) {
                console.error(error);
                throw error;

            }
        }

    };

    useEffect(() => {

        const token = getParameterByName('token');
        if (token) {
            contextValue.checkLoggedIn(token);
        }

    }, []);

    // useEffect(() => {
    //     const content = useContext(ConfigContext);
    //     content.addConfig(content.configs, {
    //         key: 'auth', value: {
    //             login: () => {
    //                 setLoginDialogOpen(true);
    //             }
    //         }
    //     })
    // }, []);
    const content = {
        login: () => {
            setLoginDialogOpen(true);
        },
        logout: () => {
            contextValue.logout();
        },
        isLoggedIn: isLoggedIn,
        firstName: session?.firstName,
        lastName: session?.lastName,
    }

    return (
        <ProductServerAuthContext.Provider value={contextValue} >
            <ConfigsProvider configJson={{ auth: content }} >
                {children}
            </ConfigsProvider>
        </ProductServerAuthContext.Provider>
    )
}